
export enum PremiumMapSearchFieldConstants {
    PREM_BUILDING_TYPE = '["bg-premium-1", "bg-premium-2", "bg-premium-3", "bg-premium-image-6", "bg-premium-image-5", "bg-premium-image-4"]',
    PREM_COUNTY_LAND_USE_CD = '["bg-premium-1", "bg-premium-3", "bg-premium-4", "bg-premium-image-2", "bg-premium-image-3", "bg-premium-5", "bg-premium-image-5", "bg-premium-image-1", "bg-premium-image-4"]',
    PREM_HOME_EQUITY = '["bg-premium-image-4", "bg-premium-3", "bg-premium-4", "bg-premium-5", "bg-premium-1", "bg-premium-image-3"]',
    PREM_LAST_SALE_PRICE = '["bg-premium-3", "bg-premium-4", "bg-premium-5", "bg-premium-1", "bg-premium-image-3"]',
    PREM_MORTGAGE_AGE = '["bg-premium-3", "bg-premium-4", "bg-premium-5", "bg-premium-1", "bg-premium-image-3"]',
    PREM_MORTGAGE_RATE = '["bg-premium-3", "bg-premium-4", "bg-premium-5", "bg-premium-1", "bg-premium-image-3"]',
    PREM_OWNER_OCCUPIED = '["bg-premium-2", "bg-premium-6", "bg-premium-image-4"]',
    PREM_OWNERSHIP_TIME = '["bg-premium-3", "bg-premium-4", "bg-premium-5", "bg-premium-1", "bg-premium-image-3"]',
    PREM_PROPERTY_VALUE = '["bg-premium-3", "bg-premium-4", "bg-premium-5", "bg-premium-1", "bg-premium-image-3"]',
    PREM_RENT_SCORE = '["bg-premium-image-4", "bg-premium-3", "bg-premium-5", "bg-premium-1", "bg-premium-image-3"]',
    PREM_SELL_SCORE = '["bg-premium-image-4", "bg-premium-3", "bg-premium-5", "bg-premium-1", "bg-premium-image-3"]',
    NO_OF_DAYS_PER_YEAR = 365,
    INDEX_ZERO = 0,
    INDEX_ONE = 1,
    INDEX_TWO = 2,
    INDEX_THREE = 3
}

export const PremiumSearchLabelStyleClassByCode = {
  '1007': 'text-uppercase',
  '1002': 'text-capitalize',
  '1005': 'text-capitalize',
  '1003': 'text-capitalize'
};

export enum InfoCards {
    PREM_BUILDING_TYPE= 'The category of the building type for the property, such as SFR, Condo, etc.',
    PREM_COUNTY_LAND_USE_CD= ' Land use category such as residential, commercial, etc.',
    PREM_HOME_EQUITY= 'Total home equity of the property ',
    PREM_LAST_SALE_PRICE= ' Last recorded sale price  ',
    PREM_MORTGAGE_AGE= 'Total mortgage age information  ',
    PREM_MORTGAGE_RATE= ' Mortgage rate information',
    PREM_OWNER_OCCUPIED= 'Occupancy status of the property',
    PREM_OWNERSHIP_TIME= 'Current ownership at the property',
    PREM_PROPERTY_VALUE= 'Current property value for the property',
    PREM_RENT_SCORE= 'This score provides the relative likelihood a property will be listed for rent within the next 6 months',
    PREM_SELL_SCORE= 'This score provides the relative likelihood a property will be listed for sale within the next 6 months'
}
